export function scrollToSection(elementId, extraOffset = 0) {
  const target = document.getElementById(elementId);
  if (!target) return;

  const nav = document.getElementById('Nav');
  window.scrollTo({
    top: Math.max(
      0,
      window.scrollY + target.getBoundingClientRect().top - (nav?.offsetHeight || 0) - extraOffset
    ),
    behavior: 'smooth',
  });
}

export function scrollToEstimate() {
  scrollToSection('Estimate-Start', 96);
}
